import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/core/hooks/useAuth";
import { montarLicoes } from "@/core/ajuda/licoes";
import { ConteudoApresentacao } from "@/core/components/ajuda/ConteudoApresentacao";
import { PAGINA_AJUDA } from "@/core/components/ajuda/ajudaUi";

/** Boas-vindas da Ajuda do Elos, aberta pela lista de lições ("Rever a apresentação"). */
export function AjudaApresentacao() {
  const navigate = useNavigate();
  const { modulosVisiveis } = useAuth();
  const total = useMemo(() => montarLicoes(modulosVisiveis).length, [modulosVisiveis]);

  return (
    <main className={PAGINA_AJUDA}>
      <ConteudoApresentacao
        totalLicoes={total}
        onComecar={() => navigate("/ajuda/conhecendo")}
        onPular={() => navigate("/inicio")}
      />
    </main>
  );
}
